<template>
  <div
    class="rfp-rr-show-full-review-157-or full-review-popup mobile-view-alignment"
    style="display: block"
  >
    <div class="rfp-rr-show-full-review-158-or review-popup-close" @click="closePopup">X</div>
    <h3 v-if="showHideSubTitles" class="rfp-rr-show-full-review-159-or rr-sub-title black clear">
      {{ headerTitle }}
    </h3>

    <rfp-ratings-product-star
      v-for="(product, key) of getPopupFields()"
      :key="key"
      :label-name="product.label"
      :label-value="product.value"
      :product-rating="product.rating"
      :is-star-rating="product.isStar"
      class="rfp-rr-show-full-review-160-or float-left"
      :class="{
        'rfp-rr-rating-rtl-float-right': isRightToLeftActive,
        'rr-avg-rating-content rfp-full-review-star-category': product.isStar,
        'rfp-full-review-sub-category': !product.isStar,
      }"
    />

    <p class="rfp-rr-show-full-review-165-or clear">{{ summary }}</p>
    <div class="rfp-rr-show-full-review-166-or rr-recomment-product clear">
      <div class="rfp-rr-show-full-review-167-or rr-sample-section float-left">
        <p style="margin-right: 0">
          <img
            :src="recommendListIcons"
            class="rfp-rr-show-full-review-168-or image-setup-for-list"
            :alt="recommendIconAltTexts"
          />
        </p>
        <p>
          {{ isRecommends }}
        </p>
      </div>
    </div>
    <div class="rfp-rr-show-full-review-169-or rr-comment-img-section clear float-left">
      <div class="rfp-rr-show-full-review-170-or review-gallery"></div>
    </div>
    <rfp-ratings-helpful
      :reported-text="reportedTexts"
      :report-text="reportTexts"
      :helpful-label="helpfulLabels"
      :rrid="rrids"
      :report-display="0"
      :update-helpful-review-api="updateHelpfulReviewApis"
      :update-not-helpful-review-api="updateNotHelpfulReviewApis"
      :report-review-api="reportReviewApis"
      :helpful-icon="helpfulIcon"
      :helpful-icon-alt="helpfulIconAlt"
      :non-helpful-icon="nonHelpfulIcon"
      :non-helpful-icon-alt="nonHelpfulIconAlt"
      :product-namess="productNames"
      :review-contentss="reviewContents"
      :review-titless="reviewTitles"
      :facebook-captionss="facebookCaptions"
      :facebook-share-enabled="facebookShareEnableds"
      :share-display-config="shareDisplayConfigs"
      :facebook-icon="facebookIcons"
      :facebook-icon-alt="facebookIconAlts"
      :facebook-tool-tips="facebookToolTips"
    ></rfp-ratings-helpful>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import RfpRatingsHelpful from '../rfp-ratings-helpful/rfp-ratings-helpful.vue';
import RfpRatingsProductStar from '../rfp-ratings-product-star/rfp-ratings-product-star.vue';

export default {
  name: 'rfp-ratings-show-full-review',
  components: {
    RfpRatingsHelpful,
    RfpRatingsProductStar,
  },
  inject: ['isRightToLeftActive'],
  props: {
    headerTitle: {
      type: String,
      required: false,
    },
    labelQualityOfProduct: {
      type: String,
      required: false,
    },
    rateQualityOfProduct: {
      type: String,
      required: false,
    },
    summary: {
      type: String,
      required: false,
    },
    rrids: {
      type: Number,
      required: false,
    },
    helpfulLabels: {
      type: String,
      required: false,
    },
    reportedTexts: {
      type: String,
      required: false,
    },
    reportTexts: {
      type: String,
      required: true,
    },
    updateHelpfulReviewApis: {
      type: String,
      required: false,
    },
    updateNotHelpfulReviewApis: {
      type: String,
      required: false,
    },
    reportReviewApis: {
      type: String,
      required: false,
    },
    isRecommends: {
      type: String,
      required: false,
    },
    helpfulIcon: {
      type: String,
      required: true,
    },
    helpfulIconAlt: {
      type: String,
      required: true,
    },
    nonHelpfulIcon: {
      type: String,
      required: true,
    },
    nonHelpfulIconAlt: {
      type: String,
      required: true,
    },
    recommendListIcons: {
      type: String,
      required: true,
    },
    recommendIconAltTexts: {
      type: String,
      required: true,
    },
    productNames: {
      type: String,
      required: true,
    },
    reviewContents: {
      type: String,
      required: true,
    },
    reviewTitles: {
      type: String,
      required: true,
    },
    facebookCaptions: {
      type: String,
      default: 'Facebook',
    },
    facebookShareEnableds: {
      type: Boolean,
      required: true,
    },
    shareDisplayConfigs: {
      type: String,
      required: true,
    },
    facebookIcons: {
      type: String,
      default: '',
    },
    facebookIconAlts: {
      type: String,
      default: '',
    },
    showHideQualityOfProducts: {
      type: Boolean,
      required: true,
    },
    showHideSubTitles: {
      type: Boolean,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
  },
  methods: {
    closePopup() {
      this.$parent.activePopup = false;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody?.classList.remove('popup_scroll');
    },
    createFieldObject(column, label, rating, star, value = '') {
      return {
        column: column,
        label: label,
        rating: parseInt(rating, 10),
        isStar: star,
        value: value,
      };
    },

    getPopupFields() {
      let productFields = [];
      const propsField = this.field;
      let starFields = {
        productQuality: this.createFieldObject(
          this.showHideQualityOfProducts,
          this.labelQualityOfProduct,
          this.rateQualityOfProduct,
          true,
        ),
        productEffectiveness: this.createFieldObject(
          propsField.showHideEffectivenessOfTheProduct,
          propsField.effectivenessOfTheProductLabel,
          propsField.effectivenessOfTheProduct,
          true,
        ),
        productTexture: this.createFieldObject(
          propsField.showHideTextureOfTheProduct,
          propsField.textureOfTheProductLabel,
          propsField.textureOfTheProduct,
          true,
        ),
        productPricePosition: this.createFieldObject(
          propsField.showHidepricePositionOfTheProduct,
          propsField.pricePositionOfTheProductLabel,
          propsField.pricePositionOfTheProduct,
          true,
        ),
        hearAboutProduct: this.createFieldObject(
          propsField.showHideHowDidYouHearAboutTheProduct &&
            propsField.howDidYouHearAboutTheProduct,
          propsField.howDidYouHearAboutTheProductLabel,
          '',
          false,
          propsField.howDidYouHearAboutTheProduct,
        ),
        gender: this.createFieldObject(
          propsField.showHideGender && propsField.gender,
          propsField.genderLabel,
          '',
          false,
          propsField.gender,
        ),
      };
      Object.values(starFields).forEach((element) => {
        if (!element.column) return;
        productFields.push(element);
      });
      return productFields;
    },
  },
};
</script>
